
import { get, del } from '../utils/http';
import checkStatus from '../utils/checkStatus';
import JSZip from 'jszip';
import JSZipUtils from 'jszip-utils';
import { saveAs } from 'file-saver';
import docCookies from '../utils/docCookie';


export const deleteFileFromS3 = (path) => {
  return del('/proxy/s3/file', { path }).then(checkStatus);
};
export const downloadFromUrl = file => () => {
  // return window.open(`${apiUrl}/s3/file?key=${path}`);
  const a = document.createElement('a');
  a.download = file.fileName || file.name || '';
  a.target = '_blank';
  a.setAttribute('download', file.fileName || file.name);
  a.href = `/proxy/s3/file?key=${encodeURIComponent(file.url || file.path)}`;
  // firefox doesn't support `a.click()`...
  a.dispatchEvent(new MouseEvent('click'));
};

export const bulkDownloadS3File = (files, zipName) => {
  // IMPORTANT: file.path here does not include s3 url and s3bucket
  const zip = new JSZip();
  let count = 0;
  files.forEach((file, fileIndex) => {
    JSZipUtils.getBinaryContent(`/proxy/s3/file?key=${encodeURIComponent(file.path || file.url)}`, (err, data) => {
      if (!err) zip.file(`${fileIndex + 1}-${file.name || file.fileName}`, data, { binary: true });
      count++;
      if (count === files.length) {
        zip.generateAsync({ type: 'blob' }).then(content => {
          saveAs(content, `${zipName || 'TCFiles'}.zip`);
        });
      }
    });
  });
};


export const loadPartners = (loadingConstant, doneConstant) => (dispatch, getState) => {
  if (loadingConstant) dispatch({ type: loadingConstant });
  return get(`/proxy/partners`)
  .then(checkStatus)
  .then(res => res.json())
  .then(response => dispatch({ type: doneConstant, payload: response }));
};

export const getUsers = (companyId, constant) => (dispatch, getState) => {
  return get(`/proxy/company/${companyId}/users`)
  .then(checkStatus)
  .then(res => res.json())
  .then(res => dispatch({ type: constant, payload: res }));
};


export function getContractingYears() {
  return dispatch => {
    dispatch({ type: 'GETTING_CONTRACTING_YEARS' });
    return fetch('/proxy/contracting/contractingYears', {
      method: 'get',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
    })
    .then(checkStatus)
    .then(res => res.json())
    .then(response => {
      dispatch({ type: 'GOT_CONTRACTING_YEARS', payload: response });
      if (response && response.length) {
        const startInCookie = docCookies.getItem('contractYearStartDate');
        const endInCookie = docCookies.getItem('contractYearEndDate');
        if (!(startInCookie && endInCookie)) {
          docCookies.setItem('contractYearStartDate', response[0].startDate, Infinity, '/');
          docCookies.setItem('contractYearEndDate', response[0].endDate, Infinity, '/');
          dispatch({ type: '[contracting]INIT_SELECTED_YEAR_FOR_CONTRACTING', payload: { ...response[0], firstLoad: true } });
        } else {
          dispatch({ type: '[contracting]INIT_SELECTED_YEAR_FOR_CONTRACTING', payload: { startDate: startInCookie, endDate: endInCookie, firstLoad: true } });
        }
      } else {
        dispatch({ type: '[contracting]INIT_SELECTED_YEAR_FOR_CONTRACTING', payload: { startDate: '2018-04-01 00:00:00.000Z', endDate: '2019-03-31 00:00:00.000Z', firstLoad: true } });
      }
    });
  };
}



// WEBPACK FOOTER //
// ./src/app/stores/actions.js